import { useMutation, useQuery } from "@tanstack/react-query";
import { instance } from "api/apiBase";
import { ApplicationNote } from "shared/app/ActivityLog/types";
import addressApi from "api/landlord/address";
import { getErrorMessage } from "utils/error";
import { toast } from "react-toastify";

export const activityLogsQueryKey = (applicationId) => [
  "ACTIVITY_LOGS",
  applicationId
];

export const useActivityLogsController = (applicationId: string) => {
  const activityLogsMeta = useQuery<ApplicationNote[]>({
    queryKey: activityLogsQueryKey(applicationId),
    queryFn: () =>
      instance
        .get(`portal/v1/applications/${applicationId}/activity_logs`)
        .then(({ data }) => data.activity_logs),
    enabled: Boolean(applicationId && applicationId !== "undefined")
  });

  const addNoteMeta = useMutation({
    mutationFn: (newNote: string) =>
      addressApi.addApplicationNote(Number(applicationId), newNote),
    mutationKey: activityLogsQueryKey(applicationId),
    onSuccess: () => activityLogsMeta.refetch(),
    onError: (err) => toast.error(getErrorMessage(err))
  });

  const editNoteMeta = useMutation({
    mutationFn: ({
      noteId,
      newMessage
    }: {
      noteId: number;
      newMessage: string;
    }) =>
      addressApi.editApplicationNote(Number(applicationId), noteId, newMessage),
    mutationKey: activityLogsQueryKey(applicationId),
    onSuccess: () => activityLogsMeta.refetch(),
    onError: (err) => toast.error(getErrorMessage(err))
  });

  const deleteNoteMeta = useMutation({
    mutationFn: (noteId: number) =>
      addressApi.deleteApplicationNote(Number(applicationId), noteId),
    mutationKey: activityLogsQueryKey(applicationId),
    onSuccess: () => activityLogsMeta.refetch(),
    onError: (err) => toast.error(getErrorMessage(err))
  });

  return { activityLogsMeta, deleteNoteMeta, editNoteMeta, addNoteMeta };
};
